import {Box, Card, CardContent} from '@mui/material'
import {useState} from 'react'
import {useNavigate} from 'react-router-dom'

import ChargeSidebar from './components/ChargeSidebar'
import CustomerTransfer from './components/CustomerTransfer'
import DigitalDeviceInfoChange from './components/DeviceUpdate'
import ManufacturerManagement from './components/ManufacturerManagement'
import MeterReaderManagement from './components/MeterReaderManagement'

export type ChargeMenuType =
  | 'meter-readers'
  | 'customer-transfer'
  | 'device-update'
  | 'manufacturer-management'

export const ChargeSettings = () => {
  const navigate = useNavigate()
  const [selectedMenu, setSelectedMenu] = useState<ChargeMenuType>('meter-readers')

  const renderContent = () => {
    switch (selectedMenu) {
      case 'meter-readers':
        return <MeterReaderManagement />

      case 'customer-transfer':
        return <CustomerTransfer />

      case 'device-update':
        return <DigitalDeviceInfoChange />

      case 'manufacturer-management':
        return <ManufacturerManagement />

      default:
        return <MeterReaderManagement />
    }
  }

  return (
    <Card sx={{width: '100%', height: '100%'}}>
      <CardContent sx={{height: '100%'}}>
        <Box display='flex' height='100%'>
          <ChargeSidebar
            selectedMenu={selectedMenu}
            onChangeMenu={setSelectedMenu}
            onMoveChargeInfo={() => navigate('/charge/info')}
          />

          <Box flex={1} pl={3} display='flex' flexDirection='column' minWidth={0}>
            {renderContent()}
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default ChargeSettings
